import {useEffect, useRef} from 'react';

export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback);

  useEffect(
    function saveLatestCallback() {
      savedCallback.current = callback;
    },
    [callback]
  );

  useEffect(
    function scheduleInterval() {
      if (delay === null) {
        return;
      }

      const id = setInterval(() => {
        savedCallback.current();
      }, delay);

      return () => {
        clearInterval(id);
      };
    },
    [delay]
  );
}
